module.exports = __webpack_public_path__ + "static/media/Digital-Service-Aliya-Abdallah.ad1f0216.m4v";